import PaginatedSearchResultMetadata, {PaginatedSearchResultMetadataDto} from "../../../search/PaginatedSearchResultMetadata"
import { SerialNumberElastic, SerialNumberElasticDto } from "./serialNumberElastic"

export type SerialNumberItemsResultDto = {
    SerialNumberItems: SerialNumberElasticDto[]
} & PaginatedSearchResultMetadataDto

export default class SerialNumberItemsResult extends PaginatedSearchResultMetadata {
    data: SerialNumberItemsResultDto
    serialNumbers: SerialNumberElastic[]

    constructor(dto: SerialNumberItemsResultDto) {
        super({
            PageSize: dto.PageSize,
            ActivePage: dto.ActivePage,
            TotalItemsCount: dto.TotalItemsCount,
        })
        this.data = dto
        this.serialNumbers = dto.SerialNumberItems?.map(sn => new SerialNumberElastic(sn)) || []
    }

    getItems(): Array<SerialNumberElasticDto> {
        return this.data.SerialNumberItems ?? []
    }
}



// WEBPACK FOOTER //
// ./src/state/listing/serial-numbers/models/serialNumberItemsResult.ts